const invertChannels = object => {
    const keys = Object.keys(object);
    return keys.reduce((acc, current) => ({ ...acc, [current]: !object[current] }), {});
};

export default invertChannels;
